import { XMLParser } from 'fast-xml-parser'

const iframesGrid = document.querySelector('#youtube-latest-grid')

const loadVideos = (domContainer) => {
    const cid = 'UCT2_JB4oY05jNBJ4i-Ib7kg'
    // const channelURL = encodeURIComponent(`https://www.youtube.com/feeds/videos.xml?channel_id=${cid}`)

    const channelURL = `https://www.youtube.com/feeds/videos.xml?channel_id=${cid}`
    const proxy = 'https://api.allorigins.win'
    // const proxyURL = `${proxy}/get?url=${encodeURIComponent(channelURL)}`
    const proxyURL = `${proxy}/get?url=${channelURL}`

    const parserOptions = {
        ignoreAttributes: false,
        attributeNamePrefix: "",
        // removeNSPrefix: true
    }

    const parser = new XMLParser(parserOptions)

    // fetch(channelURL, fetchOptions)
    fetch(proxyURL)
        .then(response => response.text())
        .then(result => {
            let obj = parser.parse(result)
            // console.log(obj.feed.entry)
            const { entry: videosArr } = obj.feed
            // console.log('videosArr',videosArr)


            videosArr.map(item => {
                // let vID = item.link.href.substring(item.link.href.indexOf('v=') + 2)
                let vID = item['yt:videoId']
                let title = item.title

                let description = item['media:group']['media:description'] || false
                // let pubDate = item.pubDate
                let pubDate = item.published
                const date = new Date(pubDate)
                const dateFormatted = new Intl.DateTimeFormat('es-es', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric'
                }).format(date)

                addVideoContainer(domContainer , vID ,title , dateFormatted , (description) ? truncateText( description, 60 ) : false )

            })
        })
        .catch(error => console.log('error ', error))


    const truncateText = (string, limit) => {
        let str = string
        str = formatNextLineString(string)
        // console.log('palabras: ', string.split(" ").length)
        const words = str.split(" ")
        let ellipsis = (words.length > limit) ? ' ...' : ''
        let truncatedString = `${words.splice(0,limit).join(" ")}${ellipsis}`
        return truncatedString
    }

    const formatNextLineString = (str) => str.replace(/\\n/g,'\n')

}



const addVideoContainer = (parentDomElement = iframesGrid, videoID, title, pubDate, desc) => {
    const src = `https://www.youtube.com/embed/${videoID}?controls=2&autoplay=0&autohide=1&color=white&modestbranding=1&playsinline=1&rel=0`

    const videoTile = document.createElement('div')
    videoTile.setAttribute('class', 'video-tile')

    const ifContainer = document.createElement('div')
    ifContainer.setAttribute('class','ast-oembed-container')

    const heading = document.createElement('h3')
    const heading_content = document.createTextNode(title)
    heading.appendChild(heading_content)

    const date = document.createElement('div')
    date.setAttribute('class', 'pub-date')
    const date_content = document.createTextNode(pubDate)
    date.appendChild(date_content)
    let description = false
    if (desc) {
        description = document.createElement('div')
        description.setAttribute('class', 'description')
        const desc_content = document.createTextNode(desc)
        description.appendChild(desc_content)
        // console.log(description)
    }
    const iframe = document.createElement('iframe')
    iframe.setAttribute('class', 'lastestVideoEmbed')
    iframe.setAttribute('allowfullscreen','')
    iframe.setAttribute('frameborder', 0)
    iframe.setAttribute('width', 1440)
    iframe.setAttribute('height', 810)
    iframe.setAttribute('src',src)
    ifContainer.appendChild(iframe)
    videoTile.appendChild(ifContainer)
    videoTile.appendChild(date)
    videoTile.appendChild(heading)
    if(desc) videoTile.appendChild(description)
    parentDomElement.appendChild(videoTile)

}

if(iframesGrid) loadVideos(iframesGrid)
